__turbopack_context__.v({
  "benefit": "CardProgram-module-scss-module__Jt8wtG__benefit",
  "benefit__checkbox": "CardProgram-module-scss-module__Jt8wtG__benefit__checkbox",
  "benefit__checkbox_selected": "CardProgram-module-scss-module__Jt8wtG__benefit__checkbox_selected",
  "benefit__description": "CardProgram-module-scss-module__Jt8wtG__benefit__description",
  "benefit__insufficient": "CardProgram-module-scss-module__Jt8wtG__benefit__insufficient",
  "benefit__insufficientBtn": "CardProgram-module-scss-module__Jt8wtG__benefit__insufficientBtn",
  "benefit__insufficientText": "CardProgram-module-scss-module__Jt8wtG__benefit__insufficientText",
  "benefit__insufficient_visible": "CardProgram-module-scss-module__Jt8wtG__benefit__insufficient_visible",
  "benefit__list": "CardProgram-module-scss-module__Jt8wtG__benefit__list",
  "benefit__price": "CardProgram-module-scss-module__Jt8wtG__benefit__price",
  "benefit__priceBlock": "CardProgram-module-scss-module__Jt8wtG__benefit__priceBlock",
  "benefit__priceBlockTop": "CardProgram-module-scss-module__Jt8wtG__benefit__priceBlockTop",
  "benefit__price_flex": "CardProgram-module-scss-module__Jt8wtG__benefit__price_flex",
  "benefit__right": "CardProgram-module-scss-module__Jt8wtG__benefit__right",
  "benefit__title": "CardProgram-module-scss-module__Jt8wtG__benefit__title",
  "benefit_inactive": "CardProgram-module-scss-module__Jt8wtG__benefit_inactive",
  "benefit_selected": "CardProgram-module-scss-module__Jt8wtG__benefit_selected",
  "callBtn": "CardProgram-module-scss-module__Jt8wtG__callBtn",
  "caption__bold": "CardProgram-module-scss-module__Jt8wtG__caption__bold",
  "modal__btn": "CardProgram-module-scss-module__Jt8wtG__modal__btn",
  "modal__btn_disabled": "CardProgram-module-scss-module__Jt8wtG__modal__btn_disabled",
  "modal__btn_hidden": "CardProgram-module-scss-module__Jt8wtG__modal__btn_hidden",
  "price": "CardProgram-module-scss-module__Jt8wtG__price",
});
